import React from 'react';
export function EditorParagraphIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M14 5h2v16h2V5h3V3H9v.022a5.5 5.5 0 000 10.956V14h3v7h2V5z"
  }));
}